import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js")